export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-green.vue?vue&type=template&id=19b7e89f&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/form-green.vue?vue&type=template&id=19b7e89f&
// module id = 1008
// module chunks = 0